import React from 'react'
import { Link } from 'react-router-dom'
import { ReactComponent as Logo } from '../../images/Logo.svg'
import { ReactComponent as Health } from '../../images/footerHealth.svg'

import css from './Footer.module.css'

const Footer = () => {
	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		})
	}

	return (
		<footer className={css.footer}>
			<div className={css.containerColumn}>
				<a
					href={process.env.REACT_APP_MAPS_URL}
					target='_blank'
					rel='noopener noreferrer'
					className={css.contactInfo}
				>
					Zielona Góra <br />ul Bohaterów Westerplatte 11 <br /> pokój 302 III PIĘTRO <br /> 65-034, Polska
				</a>
				<a href='mailto:psycholog.lewkodawid@interia.pl' className={css.contactInfo}>
					psycholog.lewkodawid@interia.pl
				</a>
				<a href='tel:+48519780316' className={css.contactInfo}>
					REJESTRACJA TELEFONICZNA  +48 519 780 316
				</a>
				<a href='tel:+48517340729' className={css.contactInfo}>
					PSYCHOLOG DAWID LEWKO  +48 517 340 729
				</a>
			</div>

			<div className={css.containerColumnSecond}>
				<nav>
					<ul className={css.navList}>
						<li className={css.navItem}>
							<Link to='/' className={css.navLink} onClick={scrollToTop}>
								Strona główna
							</Link>
						</li>
						<li className={css.navItem}>
							<Link to='/o-nas' className={css.navLink} onClick={scrollToTop}>
								O nas
							</Link>
						</li>
						<li className={css.navItem}>
							<Link to='/oferta' className={css.navLink} onClick={scrollToTop}>
								Oferta
							</Link>
						</li>
						<li className={css.navItem}>
							<Link to='/privacy-policy' className={css.navLink} onClick={scrollToTop}>
								PrivacyPolicy
							</Link>
						</li>
						<li className={css.navItem}>
							<Link to='/kontakt' className={css.navLink} onClick={scrollToTop}>
								Kontakt
							</Link>
						</li>
					</ul>
				</nav>

				<div className={css.containerFlex}>
					<Link to='/' onClick={scrollToTop}>
						<Logo />
					</Link>
					<div className={css.socialMediaContainer}>
						{/*<a
							href='/'
							target='_blank'
							rel='noopener noreferrer'
							className={css.socialMediaLink}
						>
							<Facebook/>
						</a>*/}
						<a
							href={process.env.REACT_APP_ZNANYLEKARZ_URL}
							target='_blank'
							rel='noopener noreferrer'
							className={css.socialMediaLink}
						>
							<Health />
						</a>
					</div>
				</div>
			</div>

			<div className={css.copyrightContainer}>
				<p className={css.copyrightTextMain}>
					Created by {''}
					<a
						href='https://denborgin.com/'
						target='_blank'
						rel='noopener noreferrer'
						className={css.copyrightLink}
					>
						DENBORGIN SOFRWARE
					</a>
				</p>
				<p className={css.copyrightText}>
					Copyright © {new Date().getFullYear()} denborgin.com - All Rights Reserved.
				</p>
			</div>
		</footer>
	)
}

export default Footer
